"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var SaveButtons = function (_a) {
    var handleActivateMap = _a.handleActivateMap, isActiveMap = _a.isActiveMap, isSubmitted = _a.isSubmitted, handleSave = _a.handleSave, handleCancel = _a.handleCancel;
    var t = react_i18next_1.useTranslation('common').t;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        isSubmitted && !isActiveMap && (react_1.default.createElement("div", { className: styles_module_scss_1.default.picker_map_here_section },
            react_1.default.createElement("span", null, t('ADDRESS_PICKER.PRECISE_ADDRESS')),
            ' ',
            react_1.default.createElement("a", { href: "#", className: styles_module_scss_1.default.picker_map_here_button, onClick: handleActivateMap }, t('ADDRESS_PICKER.HERE')))),
        isActiveMap && (react_1.default.createElement("div", { className: classnames_1.default('ui mini horizontal divided list', styles_module_scss_1.default.save_buttons) },
            react_1.default.createElement("div", { className: "item", onClick: handleSave },
                react_1.default.createElement("span", { className: styles_module_scss_1.default.save }, t('ADDRESS_PICKER.SAVE'))),
            react_1.default.createElement("div", { className: "item", onClick: handleCancel },
                react_1.default.createElement("span", { className: "cancel" }, t('ADDRESS_PICKER.UN_SAVE')))))));
};
exports.default = react_1.memo(SaveButtons);
